const jQuery = require("jquery");
export class PhonePrefix {

    constructor(elements) {
        this.elements = jQuery(elements);
    }

    init() {
        this.elements.each((index, element) => {

            let phoneInput = window.intlTelInput(element, {
                initialCountry: "it",
                showSelectedDialCode: true,
                utilsScript: "https://cdn.jsdelivr.net/npm/intl-tel-input@24.3.4/build/js/utils.js",
                strictMode: true,
            });

            element.addEventListener("change", () => {
                element.setCustomValidity(phoneInput.isValidNumber() ? "" : "Invalid Phone");
                this.updateValue(element, phoneInput)
            });

            element.addEventListener("focus", () => {
                this.updateValue(element, phoneInput)
            });

        });
    }

    updateValue(element, phoneInput){
        jQuery(element).val(phoneInput.getNumber(window.intlTelInput.utils.numberFormat.INTERNATIONAL));
    }
}